<template>
  <main
    :class="`home-page fade-in-fwd ${
      isMenuOpen ? 'isMenuOpenPadding' : 'isMenuClosePadding'
    }`"
  >
    <div
      class="d-flex justify-content-end align-items-center refreshbutton"
    ></div>
    <div class="w-full flex flex-col gap-2 py-4 md:py-4 md:px-4">
      <!-- Live Players Component -->
      <div
        v-if="0"
        id="room-players"
        class="w-full shadow-xl rounded-2xl overflow-hidden border border-slate-200 bg-white"
      >
        <RoomPlayers />
      </div>

      <p class="text-black mx-auto text-2xl">TODO</p>
    </div>
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import RoomPlayers from "@/slot/components/charts/RoomPlayers.vue";

const store = useStore();
const isMenuOpen = computed(() => store.state.isMenuOpen);
</script>

<style scoped></style>
